var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatternOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 316 390",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 316,
    height: 390,
    rx: 5,
    fill: ""
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M316 147.16V157.93C281.73 172.09 268.66 207.07 253.92 246.53C239.55 285.03 224.68 324.84 188.02 351.02C166.87 366.13 144.03 371.36 121.71 371.37C90.79 371.37 60.86 361.32 37.78 353.58C22.34 348.39 7.65 343.47 0 344.31V334.31C9.88 333.66 23.55 338.25 40.97 344.09C81.03 357.54 135.91 375.96 182.21 342.89C216.38 318.48 230.7 280.12 244.56 243.03C260.09 201.43 274.89 161.81 316 147.16Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.52 97.02C176.88 111.86 155.99 125.73 135.78 139.14C83.7 173.71 38.72 203.57 8.03 232.19C5.2 234.82 2.53 237.43 0 240V225.92C31.27 196.51 77.09 166.1 130.25 130.81C150.42 117.42 171.28 103.57 192.87 88.77C227.03 65.34 243.65 40.13 242.25 13.83C242 9.13 241.19 4.52 239.92 0H250.25C251.31 4.33 251.99 8.76 252.23 13.27C253.84 43.3 235.77 71.48 198.52 97.02Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternOne);
export default __webpack_public_path__ + "static/media/PatternOne.4b476ace9bf7cb4551ef4898f1540507.svg";
export { ForwardRef as ReactComponent };